<template>
  <div class="subselections-container">
    <h6
      class="subselection-of-product"
      v-for="(subselectionCategoryWithOptions, index) in subselectionCategoriesWithOptions"
      :key="index"
    >
      <span
        class="subselection-title"
      >{{subselectionCategoryWithOptions.subselectionCategory.subselectionCategoryNames.translation[language].name}}{{subselectionCategoryWithOptions.subselectionOptionsText==null || subselectionCategoryWithOptions.subselectionOptionsText.trim().length==0 ? "": ":"}}</span>
      <span class="subselection-text">{{ subselectionCategoryWithOptions.subselectionOptionsText}}</span>
    </h6>
  </div>
</template>
<script>
export default {
  name: "SubselectionsOfProductAtOrder",
  created() {
  },
  props: ["productSubselections", "language"],
  data() {
    return {
    };
  },
  computed: {
    subselectionCategoriesWithOptions: function () {
      let subselectionCategoryIds = [...new Set(this.productSubselections.map(productSubselection => productSubselection.subselectionCategoryId))];
      let subselectionCategoriesWithOptions = [];
      subselectionCategoryIds.forEach(categoryId => {

        let productSubselectionCategoryAndOptions = this.productSubselections.find(productSubselection => productSubselection.subselectionCategoryId == categoryId);
        let subselectionCategory = {
          subselectionCategoryId: productSubselectionCategoryAndOptions.subselectionCategoryId,
          subselectionCategoryNames: productSubselectionCategoryAndOptions.subselectionCategoryNames
        }

        let subselectionOptionsText = "";
        this.productSubselections.forEach(productSubselection => {
          if (productSubselection.subselectionCategoryId == categoryId) {
            subselectionOptionsText = subselectionOptionsText + productSubselection.productSubselectionOption.names.translation[this.language].name + ", ";
          }
        })

        if (subselectionOptionsText != "" && subselectionOptionsText.endsWith(", ")) {
          subselectionOptionsText = subselectionOptionsText.slice(0, -2);
        }

        let subselectionCategoryWithOptions = {
          subselectionCategory: subselectionCategory,
          subselectionOptionsText: subselectionOptionsText
        }
        subselectionCategoriesWithOptions.push(subselectionCategoryWithOptions);
      })
      return subselectionCategoriesWithOptions;
    },
  },
  methods: {
  },
  mounted() {
  }
};
</script>
<style >
.subselection-of-product {
  font-size: 14px;
  margin-bottom: 0px;
  color: #393939;
}

.subselection-title {
  font-weight: 700;
  margin-right: 5px;
}

.subselection-text {
  color: #4c4c4c;
}

.subselections-container {
  padding-left: 19px;
}
</style>